export default "__VITE_ASSET__9_YP9NQH__"